export const formatTimezoneToLocation = (tz: string) => {
  const splits = tz.split("/");
  const location = splits[splits.length - 1];

  return location.replaceAll("_", " ");
};
